/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SignupWizardFeatureRoutingModule } from './signup-wizard-feature-routing.module';
import { SignupWizardLayoutComponent } from './signup-wizard-layout/signup-wizard-layout.component';
import { StepsModule } from 'primeng/steps';
import { SharedComponentsModule } from '@well/shared-components';
import { ChooseAccountTypeComponent } from './steps/choose-account-type/choose-account-type.component';
import { AccountTypeComponent } from './account-type/account-type.component';
import { SignupCardLayoutComponent } from './signup-card-layout/signup-card-layout.component';
import { ButtonModule } from 'primeng/button';
import { TranslateModule } from '@ngx-translate/core';
import { CompanyInfoComponent } from './steps/company-info/company-info.component';
import { SignupLegalEntityInputsComponent } from './signup-legal-entity-inputs/signup-legal-entity-inputs.component';
import { InputTextModule } from 'primeng/inputtext';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CheckboxModule } from 'primeng/checkbox';
import { SharedComponentsModule as IriroSharedComponentsModule } from '@irian-ro/shared-components-module';
import { SelectModule, Select } from 'primeng/select';
import { MobileStepperDirective } from './signup-wizard-layout/mobile-stepper.directive';
import { CountryDropdownComponent } from '@well/common-libs/country-management/shell-api';
import { ConfirmationDialogModule } from '@well/confirmation-dialog';
import { MessagesModule } from 'primeng/messages';
import { ChooseSubscriptionComponent } from './steps/choose-subscription/choose-subscription.component';
import { SignupSubscriptionPlanComponent } from './subscription/signup-subscription-plan/signup-subscription-plan.component';
import { DialogModule } from 'primeng/dialog';
import { PrimengUtilsModule } from '@irian-ro/primeng-utils-module';
import { TableModule } from 'primeng/table';
import { AuthSharedModule } from '@irian-ro/auth-shared-module';
import { FirstContactComponent } from './steps/first-contact/first-contact.component';
import { FirstContactInputsComponent } from './steps/first-contact/first-contact-inputs/first-contact-inputs.component';
import { PersonManagementModule } from '@well/person-management';
import { ContactManagementModule } from '@well/contact-management';
import { ToggleSwitch } from 'primeng/toggleswitch';
import { PaymentMethodStepComponent } from './steps/payment-method-step/payment-method-step.component';
import { RadioButtonModule } from 'primeng/radiobutton';
import { SubscriptionCardViewComponent, SubscriptionCardViewWrapperComponent } from '@well/subscription-management';
import { PaymentMethodPendingStepComponent } from './steps/payment-method-pending-step/payment-method-pending-step.component';
import { LegalEntityManagementModule } from '@well/common-libs/legal-entity-management/shared';
import {
  ChoosePaymentMethodComponent,
  PaymentMethodPendingComponent,
} from '@well/company-libs/payment-method/shell-api';
import { SelectItemsModule } from '@well/select-items-shell-api';
import { AddressPickerComponent, SubmitableAddressPickerComponent } from '@well/ui-address-management';
import { DividerModule } from 'primeng/divider';
import { FormInlineErrorDirective } from '@irian-ro/shared-ui';
import { PasswordModule } from 'primeng/password';
import { FloatLabel } from 'primeng/floatlabel';
import { DatePicker } from 'primeng/datepicker';
import { MessageModule } from 'primeng/message';
import { TooltipModule } from 'primeng/tooltip';

@NgModule({
  declarations: [
    SignupWizardLayoutComponent,
    AccountTypeComponent,
    ChooseAccountTypeComponent,
    SignupCardLayoutComponent,
    CompanyInfoComponent,
    SignupLegalEntityInputsComponent,
    MobileStepperDirective,
    ChooseSubscriptionComponent,
    SignupSubscriptionPlanComponent,
    FirstContactComponent,
    FirstContactInputsComponent,
    PaymentMethodStepComponent,
    PaymentMethodPendingStepComponent,
  ],
  imports: [
    TooltipModule,
    MessageModule,
    CommonModule,
    SignupWizardFeatureRoutingModule,
    StepsModule,
    SharedComponentsModule,
    IriroSharedComponentsModule,
    AuthSharedModule,
    ButtonModule,
    TranslateModule,
    InputTextModule,
    ReactiveFormsModule,
    FormsModule,
    CheckboxModule,
    SelectModule,
    DatePicker,
    SelectItemsModule,
    CountryDropdownComponent,
    ConfirmationDialogModule,
    LegalEntityManagementModule,
    MessagesModule,
    DialogModule,
    PrimengUtilsModule,
    TableModule,
    PersonManagementModule,
    ContactManagementModule,
    ToggleSwitch,
    RadioButtonModule,
    SubscriptionCardViewWrapperComponent,
    SubscriptionCardViewComponent,
    PaymentMethodPendingComponent,
    ChoosePaymentMethodComponent,
    SubmitableAddressPickerComponent,
    AddressPickerComponent,
    DividerModule,
    FormInlineErrorDirective,
    PasswordModule,
    FloatLabel,
    Select,
    DatePicker,
    ToggleSwitch,
  ],
})
export class SignupWizardFeatureModule {}
